import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  List,
  Row,
  Modal,
} from 'antd'
import EventItem from './event.item'
import {
  addEditEvent,
  bulkAddEditEvents,
  getEvents,
  setEventList,
  setTempEvents,
} from '../../store/action/event.action'
import _ from 'lodash'
import util from '../../util/util'
import serviceInterface from '../../services/service.interface'
// import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';

const SORT_TYPE = {
  ASC: 1,
  DSC: 2,
  NONE: 3,
}

const EventList = (props) => {
  var form = useRef()
  const [sort, setSort] = useState(SORT_TYPE.DSC)
  // const [events, setEvents] = useState([]);

  useEffect(() => {
    if (sort == SORT_TYPE.ASC)
      props.setEvents(_.orderBy(props.events, ['date'], ['asc']))
    else if (sort == SORT_TYPE.DSC)
      props.setEvents(_.orderBy(props.events, ['date'], ['desc']))
    else props.setEvents(props.events)
  }, [props.events])

  useEffect(() => {
    if (props.addVisible) form.current.resetFields()
  }, [props.addVisible])

  const checkIfEdited = () => {
    for (var i = 0; i < props.editedEvents?.length; i++)
      if (props.editedEvents[i].isEdited) return true
    return false
  }

  const handleSortClick = () => {
    if (sort == SORT_TYPE.ASC) {
      setSort(SORT_TYPE.DSC)
      props.setEvents(_.orderBy(props.events, ['date'], ['desc']))
    } else if (sort == SORT_TYPE.DSC) {
      setSort(SORT_TYPE.ASC)
      props.setEvents(_.orderBy(props.events, ['date'], ['asc']))
    }
  }

  const handleFinish = (values) => {
    // props.addEvent({
    //     surgerytype: props.surgerytype,
    //     customer: props.customer?._id,
    //     company: props.company?._id,
    //     event: {
    //         ...values
    //     }
    // }, props.events).then((res) => form.current.resetFields());
    var events = serviceInterface
      .EventService()
      .modifyEvents(
        JSON.parse(JSON.stringify(props.editedEvents)),
        { ...values, isEdited: true },
        true
      )
    props.setEvents(events, props.surgerytype)
    form.current.resetFields()
  }

  const handleSave = () => {
    var evs = props.editedEvents
      .filter((e) => e.isEdited)
      .map((e) => {
        delete e.isEdited
        delete e.__typename
        return e
      })
    props.bulkSave({
      surgerytype: props.surgerytype,
      customer: props.customer?._id,
      company: props.company?._id,
      events: evs,
    })
  }

  const handleCancel = () => {
    props.getEvents({
      surgerytype: props.surgerytype,
      customer: props.customer?._id,
      company: props.company?._id,
    })
  }

  const handleModalClose = () => {
    form.current.resetFields()
    props.closeAdd()
  }

  const renderFooter = () => {
    var hidden = !checkIfEdited()
    return (
      <Row wrap={false} gutter={10} style={{ marginBottom: -24 }}>
        <Col style={{ marginLeft: 'auto' }}>
          <Button
            id={'addreminder'}
            disabled={!props.surgerytype}
            className='et-publish-btn'
            style={{ borderRadius: 4 }}
            onClick={props.openAddModal}
            danger
            type='primary'
          >
            {' '}
            ADD{' '}
          </Button>
        </Col>
        <Col hidden={hidden}>
          <Button
            className='et-cancel-btn'
            style={{ borderRadius: 4 }}
            onClick={handleCancel}
            danger
            type='primary'
          >
            {' '}
            Cancel{' '}
          </Button>
        </Col>
        <Col hidden={hidden}>
          <Button
            className='et-publish-btn'
            style={{ borderRadius: 4 }}
            onClick={handleSave}
            type='primary'
          >
            {' '}
            Publish{' '}
          </Button>
        </Col>
      </Row>
    )
  }

  const renderForm = () => {
    return (
      <Form
        style={{ margin: 18 }}
        ref={form}
        onFinish={handleFinish}
        onReset={() => form.current.resetFields()}
        layout='vertical'
        className='event-form'
      >
        <Row align='bottom' wrap={false} gutter={5}>
          <Col flex='100%'>
            <br />
            <Row wrap={false} gutter={5}>
              <Col flex={'80%'}>
                <Form.Item
                  className='ef-item'
                  name='title'
                  label={'Title'}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={'Title'} />
                </Form.Item>
              </Col>
              <Col flex='auto'>
                <Row>
                  <Form.Item
                    className='ef-item'
                    label={'Days from surgery'}
                    name='date'
                    rules={[{ required: true }]}
                  >
                    <InputNumber rows={3} placeholder={'Days'} />
                  </Form.Item>
                </Row>
              </Col>
            </Row>
            <Row wrap={false} gutter={5}>
              <Col flex={'100%'}>
                <Form.Item
                  className='ef-item'
                  name='message'
                  label={'Message'}
                  rules={[{ required: true }]}
                >
                  <Input.TextArea rows={3} placeholder={'Message'} />
                </Form.Item>
              </Col>
              {/* <Col flex="auto">
                                <Row >
                                    <Form.Item className="ef-item" >
                                        <Button block type="primary" htmlType="submit" className="ef-btn">Add</Button>
                                    </Form.Item>
                                </Row> 
                                <Row>
                                    <Form.Item className="ef-item" >
                                        <Button block type="primary" htmlType="reset" danger className="ef-btn">Clear</Button>
                                    </Form.Item>
                                </Row>
                            </Col> */}
            </Row>
          </Col>
        </Row>
        <br />
      </Form>
    )
  }

  const renderTitle = () => {
    return (
      <Col flex={'auto'} className='et-header-col'>
        {/* <Row  hidden={!props.surgerytype}>
                Add Reminder
            </Row>
            <Row hidden={!props.surgerytype}>
                {renderForm()}
            </Row> */}
        <Row className='et-title-row'>
          <Col flex='auto'>Reminders</Col>
          <Col flex='183px' onClick={handleSortClick}>
            <span style={{ cursor: 'pointer', userSelect: 'none' }}>
              <i>Days from surgery</i>{' '}
              {sort == SORT_TYPE.ASC ? <b>↑</b> : <b>↓</b>}
            </span>
          </Col>
          <Col flex={'82px'}>Actions</Col>
        </Row>
      </Col>
    )
  }

  return (
    <>
      {/* <Col hidden={!props.surgerytype} flex="auto" className="et-add-card">
            <Row  hidden={!props.surgerytype}>
                Add Reminder
            </Row>
            <Row hidden={!props.surgerytype}>
                {renderForm()}
            </Row>
        </Col> */}
      <Row id={'reminderview'}>
        <Card className='events-card' bordered={false} title={renderTitle()}>
          <List
            className='events-list'
            itemLayout='horizontal'
            dataSource={props.editedEvents}
            rowKey={(row) =>
              row?._id ? row?._id : util.generateRandomString(12)
            }
            renderItem={(item) => <EventItem event={item} />}
            loading={props.isLoading}
            footer={renderFooter()}
          />
        </Card>
      </Row>
      <Modal
        className={'filterModal reminder-modal'}
        visible={props.addVisible}
        onCancel={handleModalClose}
        title={'Add Reminder'}
        okText={'Add'}
        cancelText={'Cancel'}
        width={'70%'}
        onOk={() => {
          form.current.submit()
          props.closeAdd()
        }}
      >
        <Row>{renderForm()}</Row>
      </Modal>
    </>
  )
}

EventList.propTypes = {
  events: propTypes.array,
  isLoading: propTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    events: state.event.events,
    isLoading: state.event.isLoading,
    customer: state.profile.customer,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    events: state.event.events,
    editedEvents: state.event.tempevents,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getEvents: (params) => dispatch(getEvents(params)),
    addEvent: (params, events) => dispatch(addEditEvent(params, events)),
    setEvents: (events, surgerytype) =>
      dispatch(setEventList(events, surgerytype)),
    bulkSave: (params) => dispatch(bulkAddEditEvents(params)),
    setEvents: (events) => dispatch(setTempEvents(events)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventList)
